<template>

    <div class="p-relative">

        <Toolbar
            :is-list="true"
            v-on:toolbar-button-click="onToolbarClick"
        >
            <SearchPanel
                v-model="search"
                :has-filter="false"
            />
        </Toolbar>

        <FilterPanel
            v-if="filterDataSource"
            :dataSource="filterDataSource"
            v-bind:status.sync="year"
        >
        </FilterPanel>

        <v-row no-gutters>

            <v-col cols="12" xs="12" md="12">

                <v-data-table
                    :loading="loading"
                    :headers="headers"
                    :items="entities"
                    :options.sync="options"
                    :server-items-length="total"
                    :items-per-page="10"
                    :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                    :page.sync="options.page"
                    @page-count="paginationPageCount = $event"
                    class="elevation-1 customization-list-table pagination-list-table sticky-table"
                    @dblclick:row="rowClick"
                >

                    <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                    <template v-slot:[`item.name`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.name">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`item.reserve`]="{ item }">
                        <div class="elipsis-text-wrap">
                            <div class="etw-text-container">
                                <div class="etw-text" v-tooltip.top-center="item.reserve">
                                    {{item.reserve}}
                                </div>
                            </div>
                        </div>
                    </template>

                    <template v-slot:[`footer.prepend`]>
                        <v-pagination
                            v-model="options.page"
                            :length="paginationPageCount"
                            :total-visible="$listPaginationTotal"
                            color="teal"
                        ></v-pagination>
                    </template>

                </v-data-table>

            </v-col>

        </v-row>

    </div>

</template>

<script>
import i18n from '@/i18n';
import _ from 'lodash';
import { httpAPI } from "@/api/httpAPI";
import { mapActions } from 'vuex';

import Toolbar from '@/components/documents/Toolbar.vue';
import SearchPanel from '@/components/documents/SearchPanel.vue';
import FilterPanel from '@/components/documents/FilterPanel.vue';

export default {
    name: "ChancelleryCounters",
    columnIndex: {
        'year': 2, 
        'name': 3,
        'value': 4, 
        'registrationplace': 5, 
        'reserve': 6
    },
    components: {
        Toolbar,
        FilterPanel,
        SearchPanel
    },
    data: () => ({
        loading: false,
        total: 0,
        entities: [],
        
        dataSource: null,
        paginationPageCount: 0,
        filterDataSource: null,
    }),
    computed: {
        headers() {
            return [
                { text: i18n.t("Год"), value: 'year', width: '150px' },
                { text: i18n.t("Наименование"), value: 'name' },
                { text: i18n.t("Счетчик"), value: 'value', width: '10%' },
                { text: i18n.t("Резерв"), value: 'reserve', width: '10%'}
            ];
        },
        year: {
            get: function() {
                return this.$store.getters['global/configuration/nomenclatures/getYear'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/nomenclatures/SET_YEAR', newValue);
            }
        },
        search: {
            get: function() {
                return this.$store.getters['global/configuration/counters/getTableSearch'];
            },
            set: _.debounce(function(v) {
                this.$store.commit('global/configuration/counters/SET_TABLE_OPTION_PAGE', 1);
                this.$store.commit('global/configuration/counters/SET_TABLE_SEARCH', v);
            }, 500)
        },
        options: {
            get: function() {
                return this.$store.getters['global/configuration/counters/getTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('global/configuration/counters/SET_TABLE_OPTION', newValue);
            }
        },
        filter() {
            return {
                ...this.options,
                SearchStr: this.search,
                Year : this.year
            }
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        onToolbarClick(e, btn) {
            let action = this[btn.Action];

            if (typeof action !== 'function') {
                this.$notify.alert(`Действие ${btn.Action} не реализовано`);
                return;
            }

            action(btn);
        },
        async Refresh() {
            await this.getData(true);
        },
        async rowClick(e, row) {
            this.setOverlayVisible({ visible: true });
            await this.$router.push({ name: 'CounterCard', query: { id: row.item.id }, params: { id: row.item.id }});
            this.setOverlayVisible({ visible: false });
        },
        async getData() {
            this.total = 0;
            this.entities = [];
            this.loading = true;

            let response = await httpAPI({
                url: `api/configuration/list?collection=Chancellery.Counter&filter=${JSON.stringify(this.getTableFilterObject())}`,
                method: 'GET'
            });

            this.entities = response?.data?.Payload?.data ?? [];
            this.total = response?.data?.Payload?.total ?? 0;
            this.loading = false;
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, Year } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "year" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 2;

            return {
                SearchStr,
                Year: Year === "All" ? "": Year,
                OrderBy,
                OrderDir,
                Limit: itemsPerPage,
                Offset: (page - 1) * itemsPerPage
            };
        }
    },
async created() {
        this.setOverlayVisible({ visible: true });
        
        let fakeMenu =
        [
            { Action: "Refresh", Icon: "refresh", Items: null, Text: "Обновить", ToolTip: "Обновить_форму", Type: null, Localize: true }
        ];

        this.$store.commit('documents/toolbar/SET_MENU', { menu: fakeMenu });

        let response = await httpAPI({
            url: `api/configuration/filter?collection=Chancellery.Counter`,
            method: 'GET'
        });

        let years = response?.data.Payload?.Years?.filter(x => x[0] !== 'Все').map(x => parseInt(x[0])) ?? [];
        let sortedYears = _(years).sortBy().value().reverse();        
        let filterObject = { Filter: { Title: this.$t("Год"), Default: sortedYears[0], Items: [] } };

        for (let year of sortedYears) {
            filterObject.Filter.Items.push(({ Name: year, Count: -1, Value: String(year), HasItems: false, Requires: null, Items: null }));
        }

        this.filterDataSource = filterObject;
        this.setOverlayVisible({ visible: false });
    },
    watch: {
        filter: {
            async handler() {
                await this.getData();
            },
            deep: true,
        },
    }
}
</script>